"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TIMEOUTS = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _dataPosition = require("../helpers/data-position");

var _reactTransitionGroup = require("react-transition-group");

var _toast = _interopRequireDefault(require("./toast"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TIMEOUTS = {
  enter: 16,
  // 16 ms is the approximate time per frame while rendering 60fps.
  exit: 500 // CSS transition duration

};
exports.TIMEOUTS = TIMEOUTS;
var AUTO_DISMISS_TIMEOUT = 5000;
var DEFAULT_DELAY = 0;
var MAX_ITEMS = 2;

function getTimeoutProperties(_ref) {
  var timeout = _ref.timeout,
      timestamp = _ref.timestamp,
      now = _ref.now;

  if (timeout && timestamp) {
    return {
      timestamp: now,
      delay: timeout.delay + (now - timestamp)
    };
  }

  if (timeout) {
    return {
      timestamp: timeout.timestamp,
      delay: timeout.delay
    };
  }

  return {
    timestamp: now,
    delay: DEFAULT_DELAY
  };
}

function getMessageTimeout(delay) {
  return Number.isInteger(delay) ? delay : AUTO_DISMISS_TIMEOUT;
}

var Toaster =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Toaster, _React$Component);

  function Toaster(props) {
    var _this;

    _classCallCheck(this, Toaster);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toaster).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleAutoDismiss", function (toastId, cb) {
      var _this$state$timeouts = _this.state.timeouts,
          timeout = _this$state$timeouts[toastId],
          timeouts = _objectWithoutProperties(_this$state$timeouts, [toastId].map(_toPropertyKey));

      if (!timeout) return;
      clearTimeout(timeout.id);

      _this.setState(function () {
        return {
          timeouts: timeouts
        };
      }, cb);
    });

    _defineProperty(_assertThisInitialized(_this), "handleVisibilityChange", function () {
      var isVisible = document.visibilityState !== 'hidden';

      if (isVisible) {
        _this.handleVisible();
      } else {
        _this.handleHidden();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setupTimeouts", function () {
      var toasts = _react.default.Children.toArray(_this.props.children);

      var now = Date.now();
      var timeouts = toasts.reduce(function (allTimeouts, toast) {
        var _toast$props = toast.props,
            id = _toast$props.id,
            dismissDelay = _toast$props.dismissDelay,
            onDismiss = _toast$props.onDismiss;
        var timeout = _this.state.timeouts[id];

        if (!toast.props.dismissDelay) {
          return allTimeouts;
        }

        var timeoutValue = timeout ? timeout.value : getMessageTimeout(dismissDelay);
        var timeoutId = timeout ? timeout.id : setTimeout(function () {
          _this.handleAutoDismiss(id, onDismiss);
        }, timeoutValue);
        var properties = getTimeoutProperties({
          timeout: timeout,
          now: now,
          timestamp: _this.state.visibilityTimestamp
        });
        return _objectSpread({}, allTimeouts, _defineProperty({}, id, _objectSpread({
          id: timeoutId,
          value: timeoutValue
        }, properties)));
      }, {});

      _this.setState(function () {
        return {
          timeouts: timeouts,
          visibilityTimestamp: undefined
        };
      });
    });

    _this.state = {
      timeouts: {},
      visibilityTimestamp: undefined
    };
    return _this;
  }

  _createClass(Toaster, [{
    key: "handleVisible",
    value: function handleVisible() {
      var _this2 = this;

      var toasts = _react.default.Children.toArray(this.props.children);

      var timeouts = toasts.reduce(function (allTimeouts, toast) {
        var _toast$props2 = toast.props,
            id = _toast$props2.id,
            onDismiss = _toast$props2.onDismiss;
        var timeout = _this2.state.timeouts[id];
        if (!timeout) return allTimeouts;
        var timeoutId = setTimeout(function () {
          _this2.handleAutoDismiss(id, onDismiss);
        }, timeout.value - timeout.delay);
        return _objectSpread({}, allTimeouts, _defineProperty({}, id, _objectSpread({}, timeout, {
          id: timeoutId
        })));
      }, {});
      this.setState(function () {
        return {
          timeouts: timeouts,
          visibilityTimestamp: Date.now()
        };
      });
    }
  }, {
    key: "handleHidden",
    value: function handleHidden() {
      var _this3 = this;

      var toastIds = Object.keys(this.state.timeouts);
      var now = Date.now();
      var timeouts = toastIds.reduce(function (allTimeouts, toastId) {
        var timeout = _this3.state.timeouts[toastId];
        clearTimeout(timeout.id);
        return _objectSpread({}, allTimeouts, _defineProperty({}, toastId, _objectSpread({}, timeout, {
          delay: now - timeout.timestamp
        })));
      }, {});
      this.setState(function () {
        return {
          timeouts: timeouts
        };
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      this.setupTimeouts();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if ((0, _lodash.default)(this.props.children, prevProps.children)) {
        return;
      }

      this.setupTimeouts();
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          children = _this$props.children,
          _this$props$max = _this$props.max,
          max = _this$props$max === void 0 ? MAX_ITEMS : _this$props$max,
          props = _objectWithoutProperties(_this$props, ["children", "max"]);

      var maxChildren = _react.default.Children.toArray(children).slice(-max);

      var _this$state = this.state,
          timeouts = _this$state.timeouts,
          visibilityTimestamp = _this$state.visibilityTimestamp;
      return _react.default.createElement("div", _extends({
        className: "co-toast"
      }, (0, _dataPosition.getDataPositionProp)(props), (0, _getNativeProps.default)(props)), _react.default.createElement(_reactTransitionGroup.TransitionGroup, {
        component: null,
        appear: true
      }, maxChildren.map(function (toast) {
        var _toast$props3 = toast.props,
            id = _toast$props3.id,
            dismissDelay = _toast$props3.dismissDelay,
            onDismiss = _toast$props3.onDismiss,
            onExit = _toast$props3.onExit;
        var handleDismiss = dismissDelay ? function () {
          _this4.handleAutoDismiss(id, onDismiss);
        } : onDismiss;
        var handleExit = dismissDelay ? function () {
          _this4.handleAutoDismiss(id, onExit);
        } : onExit;
        var isAutoDismissible = !!dismissDelay;
        return _react.default.createElement(_reactTransitionGroup.Transition, {
          key: id,
          timeout: TIMEOUTS,
          onExit: handleExit,
          unmountOnExit: true
        }, function (state) {
          var timeout = timeouts[id];
          var timeoutValue = isAutoDismissible && timeout ? timeout.value : undefined;
          return _react.default.cloneElement(toast, {
            timeShift: timeout && timeout.delay,
            forceTimerUpdate: !!visibilityTimestamp,
            dismissDelay: timeoutValue,
            onDismiss: handleDismiss,
            active: state === 'entered',
            transition: state === 'exiting'
          });
        });
      })));
    }
  }]);

  return Toaster;
}(_react.default.Component);

var exclusiveVerticalPos = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('bottom', 'top');
var exclusiveHorizontalPos = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('left', 'right');
Toaster.propTypes = {
  /** {---} Sequence of: @@<Message>@@ (optional, max: ∞) */
  children: _propTypes.any,

  /** {number} Maximum number of simultaneous active toast messages */
  max: (0, _airbnbPropTypes.between)({
    gt: 0
  }),

  /** {bool} Mutually exclusive props: @@bottom@@ @@top@@ */
  bottom: exclusiveVerticalPos,

  /** {bool} Mutually exclusive props: @@bottom@@ @@top@@ */
  top: exclusiveVerticalPos,

  /** {bool} Mutually exclusive props: @@left@@ @@right@@ */
  left: exclusiveHorizontalPos,

  /** {bool} Mutually exclusive props: @@left@@ @@right@@ */
  right: exclusiveHorizontalPos,
  center: _propTypes.bool
};
Toaster.Toast = _toast.default;
var _default = Toaster;
exports.default = _default;
Toaster.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleAutoDismiss",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "toastId",
      "type": null
    }, {
      "name": "cb",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleVisibilityChange",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleVisible",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleHidden",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "setupTimeouts",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Toaster",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "{---} Sequence of: @@<Message>@@ (optional, max: \u221E)"
    },
    "max": {
      "type": {
        "name": "custom",
        "raw": "between({ gt: 0 })"
      },
      "required": false,
      "description": "{number} Maximum number of simultaneous active toast messages"
    },
    "bottom": {
      "type": {
        "name": "custom",
        "raw": "exclusiveVerticalPos"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@bottom@@ @@top@@"
    },
    "top": {
      "type": {
        "name": "custom",
        "raw": "exclusiveVerticalPos"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@bottom@@ @@top@@"
    },
    "left": {
      "type": {
        "name": "custom",
        "raw": "exclusiveHorizontalPos"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@left@@ @@right@@"
    },
    "right": {
      "type": {
        "name": "custom",
        "raw": "exclusiveHorizontalPos"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@left@@ @@right@@"
    },
    "center": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};